import './WinScreen.css'
import { useNavigate } from 'react-router-dom';

const LevelClear = () => {
  let navigate = useNavigate();

  const handleNextLevelButton = () => {
    navigate("/Level2")
  }

  return (
    <div>
        <h1>Level Clear</h1>
        <p>Click the button below to go to the next level</p>
        <button title='Next Level Button' onClick={handleNextLevelButton}>
            Next Level
        </button>
    </div>
  );
}

export default LevelClear;